import(/* webpackMode: "eager", webpackExports: ["Alert"] */ "__barrel_optimize__?names=Alert!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["AutoComplete"] */ "__barrel_optimize__?names=AutoComplete!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumb"] */ "__barrel_optimize__?names=Breadcrumb!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "__barrel_optimize__?names=Button!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "__barrel_optimize__?names=Card!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider","Checkbox"] */ "__barrel_optimize__?names=Checkbox,ConfigProvider!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Col","Row"] */ "__barrel_optimize__?names=Col,Row!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider","Pagination"] */ "__barrel_optimize__?names=ConfigProvider,Pagination!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider","Radio"] */ "__barrel_optimize__?names=ConfigProvider,Radio!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider","Segmented"] */ "__barrel_optimize__?names=ConfigProvider,Segmented!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider","Switch"] */ "__barrel_optimize__?names=ConfigProvider,Switch!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=DatePicker!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Divider"] */ "__barrel_optimize__?names=Divider!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Dropdown"] */ "__barrel_optimize__?names=Dropdown!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Empty"] */ "__barrel_optimize__?names=Empty!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Skeleton","Image","Flex","Button","Input"] */ "__barrel_optimize__?names=Flex,Skeleton!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Flex"] */ "__barrel_optimize__?names=Flex!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Form!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Input!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Menu"] */ "__barrel_optimize__?names=Menu!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["notification"] */ "__barrel_optimize__?names=notification!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Popover"] */ "__barrel_optimize__?names=Popover!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Select"] */ "__barrel_optimize__?names=Select!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Space"] */ "__barrel_optimize__?names=Space!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Spin"] */ "__barrel_optimize__?names=Spin!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs"] */ "__barrel_optimize__?names=Tabs!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tag"] */ "__barrel_optimize__?names=Tag!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "__barrel_optimize__?names=Tooltip!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Upload","LIST_IGNORE"] */ "__barrel_optimize__?names=Upload!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/antd/es/input/Password.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./fonts/marketnunito-Bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"./fonts/marketnunito-SemiBold.woff2\",\"weight\":\"600\",\"style\":\"normal\"},{\"path\":\"./fonts/marketnunito-Medium.woff2\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"./fonts/marketnunito-Regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"}]}],\"variableName\":\"nunito\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/global-error.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextTopLoaderLayout"] */ "/app/src/app/NextTopLoaderLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NetworkLayout"] */ "/app/src/app/providers/NetworkLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/antd/libs/useTheme.ts");
;
import(/* webpackMode: "eager" */ "/app/src/shared/antd/provider/AntProvider/AntProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/antd/ui/DatePicker/DatePicker.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/antd/ui/Drawer/Drawer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/antd/ui/Form/Checkbox/Checkbox.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/antd/ui/Form/Radio/Radio.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/antd/ui/Pagination/Pagination.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/antd/ui/RangePicker/RangePicker.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/antd/ui/Skeleton/Skeleton.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/antd/ui/Segmented/Segmented.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/shared/common/YaMetrika/components/universal/YaMetrika.ts");
;
import(/* webpackMode: "eager" */ "/app/src/shared/styles/base.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/ui/SplashScreen/Mobile/SplashScreen.tsx");
